import { FormSection, List, Timeline } from '@ksyos/design-system';

export function RespiAllerFollowingSteps() {
    return (
        <FormSection title="Vervolgstappen">
            <Timeline>
                <Timeline.Item>Je maakt een afspraak met de patiënt voor een huidpriktest op de praktijk</Timeline.Item>
                <Timeline.Item>
                    <Timeline.ItemHeading>De patiënt vult de digitale vragenlijst in</Timeline.ItemHeading>
                    De patiënt ontvangt automatisch een e-mail met een link naar de vragenlijst
                </Timeline.Item>
                <Timeline.Item>
                    <Timeline.ItemHeading>De huidpriktest wordt op de praktijk afgenomen</Timeline.ItemHeading>
                    Voor de patiënt:
                    <List
                        size="small"
                        styleType="bullet"
                    >
                        <List.Item>
                            Stop 72 uur van tevoren met <strong>anti-allergie tabletten</strong> (antihistaminica)
                        </List.Item>
                        <List.Item>
                            Gebruik op de dag zelf geen <strong>olie, lotion</strong> of <strong>(koel)zalf</strong> op
                            de onderarmen
                        </List.Item>
                    </List>
                </Timeline.Item>
                <Timeline.Item>
                    Binnen 5 werkdagen ontvang je de beoordeling van de allergoloog in het Ksyos platform en via een
                    Edifact in je HIS
                </Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
